export const label = {
  'de-CH': 'Vorwärts',
  'es-ES': 'Adelante',
  'fr-CA': 'Avant',
  'fr-CH': 'Avant',
  'fr-MA': 'Avant',
  'fr-TN': 'Avant',
  'nl-NL': 'Vooruit',
  'pt-BR': 'Avançar',
  'sq-XK': 'Përpara',
  'zh-TW': '向前',
  ar: 'الأمام',
  az: 'İrəli',
  be: 'Наперад',
  bg: 'Напред',
  bs: 'Naprijed',
  cnr: 'Naprijed',
  cs: 'Vpřed',
  da: 'Frem',
  de: 'Vorwärts',
  el: 'Εμπρός',
  en: 'Forward',
  es: 'Adelante',
  et: 'Edasi',
  fi: 'Eteenpäin',
  fr: 'Avant',
  he: 'קדימה',
  hr: 'Naprijed',
  hu: 'Előre',
  hy: 'Առաջ',
  id: 'Maju',
  is: 'Áfram',
  it: 'Avanti',
  ja: '進む',
  ka: 'წინ',
  ko: '앞으로',
  lt: 'Pirmyn',
  lv: 'Uz priekšu',
  mk: 'Напред',
  nl: 'Vooruit',
  no: 'Framover',
  pl: 'Dalej',
  pt: 'Avançar',
  ro: 'Înainte',
  ru: 'Вперёд',
  sk: 'Dopredu',
  sl: 'Naprej',
  sq: 'Përpara',
  sr: 'Napred',
  sv: 'Framåt',
  th: 'ไปข้างหน้า',
  tr: 'İleri',
  uk: 'Вперед',
  vi: 'Tiến',
  zh: '向前',
};
